"use strict";

/**
 * getIndex : finding target value index
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 * @param arr array
 * @param target number
 */
const getIndex = (arr, target) => {
    let start = 0, end = arr.length - 1;
    while (start <= end) {
        const mid = Math.floor((start + end) / 2);
        if (arr[mid] === target) return true;else if (arr[mid] < target) start = mid + 1;else end = mid - 1;
    }
    return false;
};

/**
 * upper_bound : returning upper bound index of target value
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 * @param arr array
 * @param target number
 */

const upper_bound = (arr, target) => {
    let idx = 0, start = 0, end = arr.length - 1;
    while (start <= end) {
        const mid = Math.floor((start + end) / 2);
        if (Number(arr[mid]) <= Number(target)) {
            idx = mid;
            start = mid + 1;
        } else {
            end = mid - 1;
        }
    }
    return idx;
};

/**
 * lower_bound : returning lower bound index of target value
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 * @param arr array
 * @param target number
 */

const lower_bound = (arr, target) => {
    let idx = 0, start = 0, end = arr.length - 1;
    while (start <= end) {
        const mid = Math.floor((start + end) / 2);
        if (Number(arr[mid]) >= Number(target)) {
            idx = mid;
            end = mid - 1;
        } else {
            start = mid + 1;
        }
    }
    return idx;
};
